export class TaskByLevelWithNotes {
  levelID: string = '';
  levelDescription: string = '';
  taskID: string = '';
  taskDescription: string = '';
  pmHours: number = 0;
  engHours: number = 0;
  nengHours: number = 0;
  qengHours: number = 0;
  cengHours: number = 0;
  eengHours: number = 0;
  lengHours: number = 0;
  grapHours: number = 0;
  progHours: number = 0;
  specHours: number = 0;
  ddsHours: number = 0;
  mechHours: number = 0;
  elecHours: number = 0;
  servicingOffice: string = '';
  notes: string = '';
  typicalOfCount: string = '';
}
